<template>
    <div class="EULA-card">
        <div class="EULA-title">
            End User License Agreement
        </div>


    <div class="EULA-container">
        <div class="section">
            <div class="section-title">Terms</div>
            <div class="section-contents">Please read this End User License Agreement (“EULA”) before You purchase a License Key for the AutoSpoto Mac App and subsequently download and use the AutoSpoto Mac App.
By purchasing a License Key and/or downloading and using the AutoSpoto Mac App, You agree, without reservation to be bound by the terms of this EULA. If You do not agree with the terms of this EULA, please do not purchase a License Key and/or download and use the AutoSpoto Mac App.
If You accept the terms and conditions in this EULA on behalf of a company or other legal entity, You warrant that You have full legal authority to accept the terms and conditions in this EULA on behalf of such company or other legal entity, and to legally bind such company or other legal entity.
You may not accept this EULA if You are not of legal age to form a binding contract with AutoSpoto.</div>
        </div>

        <div class="section">
            <div class="section-title">Definitions</div>
            <div class="section-contents">In this EULA the expressions below shall have the meaning assigned to them in this clause, unless the context requires otherwise:<br>
“Documentation” the detailed information about the AutoSpoto Mac App, its features and the system requirements as made available on the website of AutoSpoto, as amended from time to time;<br>
“AutoSpoto Mac License” the license for the AutoSpoto Mac App for the term specified on the webpage of the store where You purchase the license, or in any applicable agreement concerning the purchase of the license to Use the AutoSpoto Mac App;<br>
“License Key” a unique code provided by AutoSpoto, which enables You to activate the AutoSpoto Mac App and to subsequently use the AutoSpoto Mac App during the applicable license term;<br>
“AutoSpoto Mac App” any software application and/or all of the contents of the files and/or other media, including software setup files, licensed to You by AutoSpoto, including any Updates;<br>
“Updates” any modified versions and updates of, and additions to the AutoSpoto Mac App (excluding upgrades of the AutoSpoto Mac App);<br>
“Use” the access, download, install, copy or get benefit from using the AutoSpoto Mac App in accordance with the documentation;<br>
“You” you, the final and ultimate user of the AutoSpoto Mac App or the authorized representative of a company or other legal entity that will be the final and ultimate user of the AutoSpoto Mac App, and the company or other legal entity that will be the final and ultimate user of the AutoSpoto Mac App, if applicable.<br> </div>
        </div>

        <div class="section">
            <div class="section-title">General</div>
            <div class="section-contents">
This EULA applies to any licenses granted to You by AutoSpoto for the use of the AutoSpoto Mac App.<br>
By purchasing a License Key for the AutoSpoto Mac App and/or downloading and using the AutoSpoto Mac App, You enter into this EULA with AutoSpoto.<br>
This EULA may be modified from time to time. AutoSpoto will notify you of such modifications on its website. Any modifications to this EULA shall only apply upon acceptance by You.</div>
        </div>

        <div class="section">
            <div class="section-title">License</div>
            <div class="section-contents">
AutoSpoto grants You a non-exclusive, non-transferable, non-sublicensable, limited, revocable license to Use the AutoSpoto Mac App in accordance with this EULA. AutoSpoto reserves all rights not expressly granted to You.
AutoSpoto is and remains the owner of any intellectual property rights with respect to the AutoSpoto Mac App. You shall not acquire any ownership to the AutoSpoto Mac App as result of Your purchase of the License Key or Your Use of the AutoSpoto Mac App.</div>
        </div>

        <div class="section">
            <div class="section-title">Permitted use and restrictions</div>
            <div class="section-contents">
                 1. In order to be able to install the AutoSpoto Mac App and receive Updates and upgrades, Your computer shall have access to the Internet and shall meet the system requirements.
                <br>2. You shall Use the AutoSpoto Mac App on 1 (one) personal computers only. If You exceed the limit, AutoSpoto may block the License Key.
                <br>3. You shall Use the AutoSpoto Mac App in accordance with applicable laws and shall not:
                <br>&emsp; 1. rent, lease, lend, sell, redistribute, sublicense or otherwise commercially exploit the License Key;
                <br>&emsp; 2. assign the License Key or the AutoSpoto Mac License without prior written approval of AutoSpoto;
                <br>&emsp; 3. Use the AutoSpoto Mac App for any unlawful or illegal activity, or to facilitate an unlawful or illegal activity;
                <br>&emsp; 4. delete or alter any disclaimers, warnings, copyright or other proprietary notices accompanying the AutoSpoto Mac App; or
                <br>&emsp; 5. copy (except as otherwise provided in this EULA), adapt, translate, decompile, reverse engineer, disassemble, attempt to derive the source code of, modify or create derivative works of the AutoSpoto Mac App and the License Key or any parts thereof, except to the extent permitted by applicable law.
<br> 4. AutoSpoto may modify the AutoSpoto Mac App at any time at its sole discretion and without notice to You, for example to comply with applicable law or a court order, to avoid a third party infringement claim or to provide Updates and upgrades.</div>
        </div>

        <div class="section">
            <div class="section-title">Maintenance and support </div>
            <div class="section-contents">
AutoSpoto will notify You of any available Updates and upgrades.
You will be entitled to receive Updates free of charge indefinitely.
You may need to pay an additional fee in order to be able to download a major upgrade.
You can download available Updates and upgrades from the website of AutoSpoto.
Any maintenance and support provided by AutoSpoto, including the provision of Updates and upgrades, will be provided in an adequate way on an “as is” basis without any warranty, as soon as reasonably practicable, subject to availability of personnel.
The terms of this EULA will govern any Updates.
                </div>
        </div>

        <div class="section">
            <div class="section-title">Use of data </div>
            <div class="section-contents">
                1. AutoSpoto and its subsidiaries may periodically collect and use technical and related data concerning the AutoSpoto Mac App You have licensed, including about the version number of the AutoSpoto Mac App You have installed and about the system You have installed the AutoSpoto Mac App on. AutoSpoto will use such data to facilitate maintenance and support with respect to the AutoSpoto Mac App, to improve its products and to provide further services or technologies to You. <br>
2. AutoSpoto may process personal data with respect to You, if and to the extent necessary to provide the License Key, to provide maintenance and support to You with respect to the AutoSpoto Mac App and to comply with its obligations under this EULA. To the extent AutoSpoto will process personal data, it will comply with its obligations under applicable data protection law.
                </div>
        </div>

        <div class="section">
            <div class="section-title">Disclaimer </div>
            <div class="section-contents">
                1. You Use the AutoSpoto Mac App at Your own risk and the entire risk as to satisfactory quality, performance and accuracy is with You. <br>
2. The AutoSpoto Mac App and accompanying documentation are provided on an “as is” and “as available” basis without warranty - express or implied - of any kind, and AutoSpoto specifically disclaims the warranty of fitness for a particular purpose. No oral or written advice given by AutoSpoto, its dealers, distributors, agents or employees shall create a warranty or in any way increase the scope of this warranty and You may not rely upon such information or advice.
                </div>
        </div>

        <div class="section">
            <div class="section-title">Liability limitation </div>
            <div class="section-contents">
                1. The liability of AutoSpoto and any third party that has been involved in the creation, production, or delivery of the AutoSpoto Mac App for all damages arising out of or in any way relating to the AutoSpoto Mac License, the License Key, the AutoSpoto Mac App and/or this EULA shall in no event exceed the total amount(s) paid by You to AutoSpoto in the preceding 12 (twelve) months. <br>
2. AutoSpoto and any third party that has been involved in the creation, production, or delivery of the AutoSpoto Mac App are under no circumstances liable for consequential or indirect damages (including damage for loss of profit, business interruption, loss of data, and the like arising out of the use or inability to use the AutoSpoto Mac App).<br>
3. The limitations of liability referred to in clause 9.1 and 9.2 shall not apply in the event that: (i) any negligence on the part of AutoSpoto leads to death or physical injury or (ii) damages arise from the intent, willful misconduct or gross negligence of AutoSpoto or the management of AutoSpoto.<br>
                </div>
        </div>

        <div class="section">
            <div class="section-title">Termination </div>
            <div class="section-contents">
                1. This EULA will continue to be in force until the expiry or termination of the AutoSpoto Mac License. <br>
                2. AutoSpoto is entitled to terminate the AutoSpoto Mac License by blocking the License Key during the license term with immediate effect and without prior notice in the event You fail to comply with the terms in this EULA, in the event You fail to pay Your fee for the License Key within the applicable payment term, or in the event AutoSpoto is required to do so by law or an order of an applicable court.<br>
                3. Upon termination of the AutoSpoto Mac License, You shall cease all use of the AutoSpoto Mac App.<br>
                4. You acknowledge that the provisions of this EULA, which by their nature are intended to survive termination, will remain in effect after termination of this EULA.<br>
            </div>
        </div>

        <div class="section">
            <div class="section-title">Governing law and disputes </div>
            <div class="section-contents">
                1. This EULA shall be governed by and construed in accordance with the laws of Canada, excluding its conflicts of law rules. <br>
2. Any dispute between AutoSpoto and You shall exclusively be submitted to the competent court in Toronto, Canada. <br>
            </div>
        </div>

        </div>
    </div>
</template>

<style scoped>

.EULA-card {
    margin: 0;
    padding: 0;
    scroll-behavior: smooth;
    background: linear-gradient(0deg, rgba(0, 0, 0, 1) 0%, rgba(59, 59, 59, 1) 35%);
}

.EULA-title {
    text-align: center;
    font-family: JosefinSansBold;
    font-size: 20pt;
    color: white;
    padding-top: 30px;
    padding-bottom: 30px;
}

.EULA-container {
    margin: auto;
    max-width: 1200px;
    padding-left: 12px;
    padding-right: 12px;
}

.section {
    padding-bottom: 20px;
}

.section-title {
    font-family: JosefinSansSemiBold;
    font-size: 18pt;
    color: white;
}

.section-contents {
    font-family: JosefinSansRegular;
    font-size: 12pt;
    color: white;
}
</style>

<script setup>
    // import { useRouter } from "vue-router";
    // const router = useRouter();
</script>

<script>
  export default {
      methods: {
        mounted () {
          window.scrollTo(0, 0);
      }
    },
  };
</script>